<template><el-tag size="mini">{{ text }}</el-tag></template>
<script>export default { name: 'YuqingPlatformTag', props: ['value'], computed: { text () { return ({xiaohongshu:'小红书',douyin:'抖音',kuaishou:'快手',bilibili:'B站',weibo:'微博',wechat_mp:'公众号'})[this.value] || this.value || '-' } } }</script>
